import { Box, Button, makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import { useTranslate } from "react-admin";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.orange,
    borderRadius: 18,
    width: 140,
    minHeight: 35,
    height: 35,
    fontSize: 14,
    color: theme.white,
  },
  icon: {
    width: 20,
    height: 20,
    color: theme.white,
  },
}));
const AddMemberButton = () => {
  const history = useHistory();
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <Box>
      <Button
        variant="contained"
        className={classes.button}
        startIcon={<AddIcon className={classes.icon} />}
        onClick={() => history.push("/customers/register")}
      >
        {translate("ra.text.ci.addMember")}
      </Button>
    </Box>
  );
};

export default AddMemberButton;
